import type ProviderAccount from '~/types/ProviderAccount';
import type ServiceLevel from '~/types/ServiceLevel';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { type MappedProviderAccount } from '~/types/ProviderAccount';
import { type MappedServiceLevelsToken } from '~/types/ServiceLevel';
import { getFailed, getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type ProvidersState = {
  readonly mappedServiceLevelsByAccount: MappedProviderAccount;
  readonly mappedServiceLevelsByToken: MappedServiceLevelsToken;
  readonly serviceLevelsByAccountRequest: Requestable<ProviderAccount[], string>;
};

const initialState: ProvidersState = {
  mappedServiceLevelsByAccount: {},
  mappedServiceLevelsByToken: {},
  serviceLevelsByAccountRequest: getNotRequested(),
};

const reducer = (state: ProvidersState = initialState, action: ActionTypes): ProvidersState => {
  switch (action.type) {
    case ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT:
      return {
        ...state,
        serviceLevelsByAccountRequest: getRequesting(),
      };
    case ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_SUCCESS:
      const serviceLevelsByAccount = getSuccess(action.payload.providerAccounts);
      let mappedAccounts: Record<string, ProviderAccount[]> = {};
      let mappedServiceLevelsByToken: Record<string, ServiceLevel[]> = {};

      for (const account of serviceLevelsByAccount.data) {
        // create mappedAccounts Object
        if (!mappedAccounts[account.providerToken])
          mappedAccounts[account.providerToken] = [account];
        else mappedAccounts[account.providerToken].push(account);

        // create mappedServiceLevelsByToken
        for (const serviceLevel of account.serviceLevels) {
          const account_object_id = account.objectId;
          let serviceLevelWithObjectId = { ...serviceLevel, account_object_id };

          // set the account_object_id on the parent, if the parent exists
          if (serviceLevelWithObjectId.parent_servicelevel && account_object_id)
            serviceLevelWithObjectId.parent_servicelevel.account_object_id = account_object_id;

          if (mappedServiceLevelsByToken[serviceLevel.token])
            mappedServiceLevelsByToken[serviceLevel.token].push(serviceLevelWithObjectId);
          else mappedServiceLevelsByToken[serviceLevel.token] = [serviceLevelWithObjectId];
        }
      }

      return {
        ...state,
        mappedServiceLevelsByAccount: mappedAccounts,
        mappedServiceLevelsByToken,
        serviceLevelsByAccountRequest: serviceLevelsByAccount,
      };
    case ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_ERROR:
      return {
        ...state,
        serviceLevelsByAccountRequest: getFailed(action.payload.errorMessage),
      };
    default:
      return state;
  }
};

export default reducer;
